import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import useUser from '@hooks/auth/useUser';
import useRewardPolicies from '@hooks/useRewardPolicies';
import BarcodeIcon from '@icons/BarcodeIcon';
import CouponIcon from '@icons/CouponIcon';
import StampIcon from '@icons/StampIcon';
import { useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import TierInfo from './TierInfo';
import UserRewardItem from './UserRewardItem';

function UserRewards() {
    const { user } = useUser();
    const { push } = useFlow();
    const { t } = useTranslation('main', { keyPrefix: 'rewards' });
    const { stampEnabled } = useRewardPolicies();
    return (
        <Column spacing={16} css={css`
            padding: 0 20px;;
        `}>
            <Text color={colors.gray8} fontWeight='bold' size='xl'>
                {t('userName', {
                    name: user?.nickname
                        || user?.identityInfo?.name
                        || t('defaultName'),
                })}
            </Text>
            <TierInfo/>
            <Container>
                {stampEnabled && (
                    <UserRewardItem icon={StampIcon}
                        label={t('stamp')}
                        content={user?.stampCount?.toString() || ''}
                        onClick={() => push('StampsActivity', {})} />
                )}
                <UserRewardItem icon={CouponIcon}
                    label={t('coupon')}
                    content={t('couponCount', { couponCount: `${user?.couponCount || 0}` })}
                    onClick={() => push('CouponActivity', { type: 'MY' })} />
                <UserRewardItem icon={BarcodeIcon}
                    onClick={() => push('BarcodeModal', {})}
                    label={t('barcode')}
                    content={t('membership')} />
            </Container>
        </Column>
    );
}

const Container = styled.div`
    background-color: ${colors.gray1};
    border-radius: 8px;
    padding: 0 8px;
    width: 100%;
    margin-bottom: 28px;
    display: flex;
`;

export default UserRewards;
